import React, { ReactElement } from 'react';
import cc from 'classcat';
import styled from 'styled-components';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

const Select = styled.div`
  border-radius: 6px;
  background-color: var(--v3-black-6);
  line-height: 32px;
  height: 32px;
  color: var(--v3-text-color);
  padding: 0 24px 0 8px;
  display: inline-block;
  position: relative;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
`;

type Props = {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  expanded?: boolean;
};

export const PickerButton = ({ expanded, ...props }: Props): ReactElement => {
  return (
    <Select {...props}>
      <span className="globalEllipsis">{props.children}</span>
      <GlobalIcon
        lib="generic"
        name="caretDownSmall"
        theme="default"
        size={EIconSize._20}
        position="absolute"
        className={cc([
          'pickerButton__caret',
          { 'pickerButton__caret--expanded': expanded }
        ])}
      />
    </Select>
  );
};
